<template>
  <v-container pa-0 pt-1>
    <div v-if="debug">
      <code>{{ value }}</code>
    </div>
    <v-card outlined>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.totalPrice="{ item }">
          {{ item.totalPrice | priceLabeler }}
        </template>
        <template v-slot:item.commission="{ item }">
          {{ item.commission | priceLabeler }}
        </template>
      </v-data-table>
    </v-card>
    <v-container>
      <v-row>
        <v-col>
          <h6 class="caption text-center">COMMISSION</h6>
          <h5 class="text-center" style="font-size: 1.8vw">
            {{ commission.toFixed(2) | priceLabeler }}
          </h5>
        </v-col>
        <v-col>
          <v-row
            align="center"
            v-if="$store.getters.hasAccessTo('itineraries:commission', true)"
          >
            <v-text-field
              v-model.number="adjustment"
              label="Commission Adjustment"
              :outlined="outlinedInputs"
              hide-details
            ></v-text-field>
            <v-btn text class="ml-2" color="primary" large @click="onSave"
              ><v-icon left>mdi-content-save-outline</v-icon> Save</v-btn
            >
          </v-row>
        </v-col>
        <v-col>
          <h6 class="caption text-center">NET COMMISSION</h6>
          <h5 class="text-center" style="font-size: 1.8vw">
            {{ netCommission.toFixed(2) | priceLabeler }}
          </h5>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
const UPDATE_IT_HEADER = gql`
  mutation updateItineraryHeader($id: ID!, $input: ItineraryHeaderInput!) {
    updateItineraryHeaderInfo(id: $id, itineraryHeaderInput: $input) {
      id
      profit {
        commission
        commissionAdjustment
      }
    }
  }
`;
export default {
  name: "itinerary-commission",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      adjustment: this.value ? this.value.profit.commissionAdjustment : 0,
      headers: [
        { text: "Supplier", value: "supplierName" },
        { text: "Service", value: "serviceName" },
        { text: "Sell Price", value: "totalPrice" },
        { text: "Commission", value: "commission" },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    commission() {
      return this.value ? Number(this.value.profit.commission) : 0;
    },
    netCommission() {
      return this.commission + Number(this.adjustment);
    },
    items() {
      return this.value && this.value.items
        ? this.value.items.edges
            .map(removeGQLTypename)
            .map(this.addExtras)
            .flat()
        : [];
    },
  },

  methods: {
    addExtras(item) {
      let items = [item];
      if (item.extras) {
        items.push(
          item.extras.map((extra) => {
            return {
              ...item,
              id: extra.id,
              serviceName: extra.name,
              totalPrice: extra.totalSell,
              commission: extra.commission,
            };
          })
        );
      }
      return items.flat();
    },
    onSave() {
      this.$apollo
        .mutate({
          mutation: UPDATE_IT_HEADER,
          variables: {
            id: this.value.id,
            input: {
              commissionAdjustment: Number(this.adjustment),
            },
          },
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryCommission.vue